<template>
	<div class="googleauth"></div>
</template>

<script>
export default {

	data: () => ({
		user: null
	}),

	mounted() {
		this.appendScript("https://apis.google.com/js/platform.js?onload=googleInit")
	},

	props: {
		target: { default: 'btngoogleauth' },
		clientid: { default: "YOUR-CLIENT-ID.apps.googleusercontent.com" }
	},

	computed: {
		loggedIn() { return this.user != null }
	},

	methods: {
		appendScript(url) {
			let head = document.getElementsByTagName('head')[0];
			let theScript = document.createElement('script');
			theScript.type = 'text/javascript';
			theScript.src = url;
			theScript.onreadystatechange = () => { };
			theScript.onload = () => { this.init() };
			head.appendChild(theScript);
		},

		onSignIn (googleUser) {
			let profile = googleUser.getBasicProfile();
			this.user = googleUser;
			//console.log('googleUser', googleUser)
			//console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
			//console.log('Name: ' + profile.getName());
			//console.log('Image URL: ' + profile.getImageUrl());
			//console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
			this.$emit('input', this.loggedIn)
		},

		signOut() {
			let auth2 = gapi.auth2.getAuthInstance();
			auth2.signOut().then(() => {
				console.log('User signed out.');
				this.user = null;
				this.$emit('input', this.loggedIn)
			});
		},

		init()
		{
			this.$nextTick(() => {

				gapi.load('auth2', () => {
					gapi.auth2.init({ client_id: this.clientid }).then(() => {

						// DO NOT ATTEMPT TO RENDER BUTTON UNTIL THE 'Init' PROMISE RETURNS
						this.showAuthButton = true

						let options = {
							'scope': 'profile email',
							'width': 240,
							'height': 48,
							'longtitle': true,
							'theme': 'dark',
							'onsuccess': this.onSignIn,
							'onfailure': () => { /* console.log('fail loading google auth') */}
						}

						gapi.signin2.render(this.target, options);
					})
				})
			})
		}
	}
}
</script>

<style lang="scss" scoped>

</style>

